import React from 'react'
import ReactDOM from 'react-dom/client'
import { Provider } from 'react-redux';
import store, { RootState } from './store/store';
import { ReduxRouter } from '@lagunovsky/redux-react-router'

import App from './App/App';

// Load i18n Localization
import './i18n/i18n';

// Theme
import theme from './theme'
import { ThemeProvider } from '@mui/material/styles';

import { languageChanged, langUpdated } from './App/app';
import history from './history';
import { initStorage } from './store/middlewares/storage';
import { initAmplify } from './store/middlewares/amplify';
import { authenticateUser } from './store/api/authenticate-user';
import { production } from './environments';
import i18n, { LanguageCode, dialects, languageTypes } from './i18n/i18n';


// If production env add this
// This won't be a part of the build.
if( !production ) import( './dev-tools' );

store.dispatch( initStorage() );

store.dispatch( initAmplify() );
store.dispatch( authenticateUser() );


// Language

const state = store.getState();
 
// If language has been set by search / query parameter
// We need to store language value in local storage as well, which is handled by langUpdated
// languageChanged is used to update the language in this application
if( state.app.searchParameters.lang ) {
  store.dispatch( languageChanged( state.app.searchParameters.lang ) );
  store.dispatch( langUpdated( state.app.searchParameters.lang ) );
// Else, check browser language
} else {
  const browserLanguage  = ( dialects[navigator.language.split('-')[0]] || 'en' ) as LanguageCode;
  const lang = languageTypes.map(item => item.code).includes(browserLanguage) ? browserLanguage : 'en';
  store.dispatch( languageChanged( lang  ) );
  store.dispatch( langUpdated( lang ) );

}

const routerSelector = (state: RootState ) => state.router;

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.Fragment>
    <Provider store={store}>
      <ThemeProvider theme={ theme }>
        <ReduxRouter
          history={ history }
          routerSelector={ routerSelector }
          children={<App />}
        />
      </ThemeProvider>
    </Provider>
  </React.Fragment>
);
